import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/insights/kapitel5-vs-kapitel7/graduation.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/insights/kapitel5-vs-kapitel7/jars.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/insights/kapitel5-vs-kapitel7/punch-clock.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/insights/sandbox-vs-vollintegration/laptop.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/insights/sandbox-vs-vollintegration/pilot.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/insights/sandbox-vs-vollintegration/server.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/family-fund/debra-fiscal.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/family-fund/hero.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/phobia/hero.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/phobia/jenny-wilson.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/unseal/emily-selman.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/app/work/unseal/hero.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorWithCallToAction"] */ "/app/src/components/Calculator.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/FadeIn.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/GrayscaleTransitionImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/GridPattern.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HubSpotMeetingEmbed"] */ "/app/src/components/HubSpotMeetingEmbed.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/RootLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ScrollGrayscale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StylizedImage"] */ "/app/src/components/StylizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackedLink"] */ "/app/src/components/TrackedLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/images/clients/b42/B42_Logo_onyx.svg");
;
import(/* webpackMode: "eager" */ "/app/src/images/entwicklung.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/iphone_mockup.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/lukas_meeting.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/adonai_hochkant.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/annika.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/gabriel.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/katja.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/lukas.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/malin.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/mars-weihs.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/max.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/morten.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/paddy.png");
;
import(/* webpackMode: "eager" */ "/app/src/images/team/silke.jpeg");
